import {
    noDefaultArchivePolicyText,
    noDefaultDeletePolicyText,
    useParentFolderPolicyText,
} from './createInheritSubMenuItem.locstring.json';
import loc from 'owa-localize';
import ElcFolderType from 'owa-service/lib/contract/ElcFolderType';
import RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import createSubMenuItem from './createSubMenuItem';

/**
 * Utility to create the inherit sub menu item
 * @param retentionId unique retention id of tag
 * @param retentionPolicyTags list of policy tags
 * @param folderType folder type
 * @param isArchive denotes whether this item belongs to archive or delete section
 * @param isChecked denotes whether the option is checked
 * @param onClickCallback callback on clicking the option
 */
export default function createInheritSubMenuItem(config: {
    retentionId: string;
    retentionPolicyTags: RetentionPolicyTag[];
    folderType: ElcFolderType;
    isArchive: boolean;
    isChecked: boolean;
    onClickCallback: (
        ev: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item: IContextualMenuItem
    ) => void;
}): IContextualMenuItem {
    const {
        retentionId,
        retentionPolicyTags,
        folderType,
        isArchive,
        isChecked,
        onClickCallback,
    } = config;
    const defaultDisplayName = getDisplayNameForPersonalFolders(folderType, isArchive);
    // For system folders and root folders, find corresponding folder policy tag.
    const displayName =
        folderType != ElcFolderType.Personal
            ? getDisplayNameForSystemAndRootFolders({
                  retentionPolicyTags: retentionPolicyTags,
                  folderType: folderType,
                  isArchive: isArchive,
                  defaultName: defaultDisplayName,
              })
            : defaultDisplayName;
    return createSubMenuItem({
        retentionId: retentionId,
        displayName: displayName,
        isChecked: isChecked,
        subMenuProps: null,
        onClickCallback: onClickCallback,
    });
}

function getDisplayNameForPersonalFolders(folderType: ElcFolderType, isArchive: boolean): string {
    return folderType == ElcFolderType.All
        ? isArchive
            ? loc(noDefaultArchivePolicyText)
            : loc(noDefaultDeletePolicyText)
        : loc(useParentFolderPolicyText);
}

function getDisplayNameForSystemAndRootFolders(config: {
    retentionPolicyTags: RetentionPolicyTag[];
    folderType: ElcFolderType;
    isArchive: boolean;
    defaultName: string;
}): string {
    const { retentionPolicyTags, folderType, isArchive, defaultName } = config;
    return retentionPolicyTags.reduce((acc, tag) => {
        return tag.Type === folderType && tag.IsArchive == isArchive ? tag.DisplayName : acc;
    }, defaultName);
}
